import { Bar } from '@ant-design/charts';
import { IComponentProperty, ComponentPropertyType } from '../ComponentProperty';
import { v4 as uuidv4 } from 'uuid';
import React from 'react';
import { Link } from 'react-router-dom';
import useDataSource from '../DataSource';

export const Props: Array<IComponentProperty> = [
    { "name": "id", "type": ComponentPropertyType.String, "required": true, "description": "The ID for this chart", displayName: "Id" },
    { "name": "dataSource", "type": ComponentPropertyType.DataSource, "required": true, "description": <>The <Link to="/admin/automation/scripts" target="_blank">script</Link> or <Link to="/admin/apis/endpoints" target="_blank">API</Link> data source for this chart.</>, displayName: "Data Source", category: "Data Source" },
    { "name": "color", "type": ComponentPropertyType.String, "required": false, "description": "The color of the line.", displayName: "Color" },
    { "name": "xField", "type": ComponentPropertyType.String, "required": true, "description": "The field containing the label for the x-Axis.", displayName: "X Axis Field" },
    { "name": "yField", "type": ComponentPropertyType.String, "required": true, "description": "The field containing the data for the y-Axis.", displayName: "Y Axis Field" },
    { "name": "scrollbar", "type": ComponentPropertyType.Boolean, "required": false, "description": "Whether to display a scrollbar when there are many bars.", displayName: "Scrollbar" },
]

export const Constructor = () => {
    return {
        "$type": 'PowerShellUniversal.Components.BarChart, PowerShellUniversal',
        "type": "Bar",
        "id": uuidv4(),
    }
}

export function Component(props) {
    const { data, isLoading } = useDataSource(props);

    var scrollbar = null;
    if (props.scrollbar) {
        scrollbar = {
            type: "vertical"
        }
    }

    if (isLoading) {
        return <div />
    }

    return <Bar color={props.color} loading={isLoading} data={data} xField={props.xField} yField={props.yField} scrollbar={scrollbar} />
}